<template>
  <div class="content">
    <el-dialog top="5vh"
               append-to-body
               :title="title"
               :visible.sync="dialogFormVisible"
               @close="closeDiag"
               :modal-append-to-body="false"
               width="1450px">
      <div class="header">
        <div class="title">直播列表</div>
        <div class="dialog-footer">
          <span style="marginRight:10px">使用研盒考研App/百家云平台授课</span>
          <el-switch v-model="bind_live_room_status"
                     :active-value="1"
                     :inactive-value="0"
                     @change="change">
          </el-switch>

          <!-- <el-button type="primary"
                     @click="handleCopy"
                     size="small"
                     :data-clipboard-text="clipboardText"
                     class="copy">邀请制定</el-button> -->
        </div>

      </div>
      <div class="table-wrap">
        <el-table ref="table"
                  :data="tableData"
                  style="width: 100%"
                  row-key="id"
                  border
                  :header-cell-style="{ background: '#f2f6fc' }"
                  :default-expand-all="false"
                  :expand-row-keys="expands"
                  @expand-change="handleExpendChange"
                  row-class-name="row-item"
                  :tree-props="{ children: 'children' }">
          <el-table-column prop="id"
                           label="上课Id"
                           width="110"
                           align="center">
          </el-table-column>
          <el-table-column label="上课时间"
                           width="150"
                           align="center">
            <template slot-scope="scope">
              {{ scope.row.baijia_resource_room_obj ? $moment(scope.row.baijia_resource_room_obj.start_time).format("YYYY-MM-DD HH:mm") : "" }}
            </template>
          </el-table-column>
          <el-table-column label="直播主题"
                           width="150"
                           align="center">
            <template slot-scope="scope">
              {{ scope.row.baijia_resource_room_obj ?scope.row.baijia_resource_room_obj.title :'' }}
            </template>
          </el-table-column>
          <el-table-column prop="status"
                           label="在线状态"
                           width="110"
                           align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status"
                      type="success">已发布</el-tag>
              <el-tag v-if="!scope.row.status"
                      type="warning">未发布</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="lesson_start_end_status"
                           label="直播状态"
                           width="110"
                           align="center">
            <template slot-scope="scope">
              <el-tag :type="getLiveStatus(scope.row)=='进行中'? 'success' : getLiveStatus(scope.row) === '未开始'?'warning' :'danger'"
                      v-if="scope.row.baijia_resource_room_obj">{{getLiveStatus(scope.row)}}</el-tag>
            </template>
          </el-table-column>

          <el-table-column class-name="edit-cell"
                           label="关联教室号"
                           width="200"
                           align="center">
            <template slot-scope="scope"
                      v-if="scope.row.baijia_resource_room_obj">
              <el-tag>{{scope.row.baijia_resource_room_obj.room_id}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column class-name="edit-cell"
                           label="回放时长"
                           width="120"
                           align="center">
            <template slot-scope="scope"
                      v-if="scope.row.baijia_resource_room_video_obj">
              <el-tag>{{formatTime(scope.row.baijia_resource_room_video_obj.length)}}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间"
                           width="150"
                           align="center">
            <template slot-scope="scope">
              {{ scope.row.baijia_resource_room_obj ? $moment(scope.row.baijia_resource_room_obj.create_time).format("YYYY-MM-DD HH:mm") : "" }}
            </template>
          </el-table-column>
          <el-table-column label="更新时间"
                           width="150"
                           align="center">
            <template slot-scope="scope">
              {{ scope.row.baijia_resource_room_obj ? $moment(scope.row.baijia_resource_room_obj.update_time).format("YYYY-MM-DD HH:mm") : "" }}
            </template>
          </el-table-column>

          <el-table-column class-name="action-cell"
                           label="操作"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <div class="menu-wrap">
                <el-link type="primary"
                         v-if="scope.row.baijia_resource_room_obj"
                         :underline="false"
                         @click="handleEdit(scope.row)">编辑 |</el-link>
                <el-link type="primary"
                         v-if="scope.row.status==0&&scope.row.baijia_resource_room_obj"
                         :underline="false"
                         @click="changeLive(scope.row,1)">发布</el-link>
                <el-link type="danger"
                         v-if="scope.row.status==1&&scope.row.baijia_resource_room_obj"
                         :underline="false"
                         @click="changeLive(scope.row,0)">下线</el-link>
                <el-link type="primary"
                         @click="handlePreview(scope.row)"
                         v-if="scope.row.baijia_resource_room_video_obj">预览</el-link>
                <el-link type="primary"
                         @click="handlePreview(scope.row)"
                         v-else-if="scope.row.baijia_resource_room_obj">预览</el-link>
                <el-link type="info"
                         v-else>预览</el-link>

                <!-- <el-switch v-model="scope.row.status"
                           v-if="scope.row.baijia_resource_room_obj"
                           :active-value="1"
                           :inactive-value="0"
                           @change="changeLive(scope.row)">
                </el-switch> -->
                <!-- <span v-if="scope.row.status==0&&scope.row.baijia_resource_room_obj"
                      style="marginLeft:5px;">开</span>
                <span v-if="scope.row.status==1&&scope.row.baijia_resource_room_obj"
                      style="marginLeft:5px;">关</span> -->

              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog append-to-body
               title="编辑"
               :visible.sync="editVisisdiag"
               @close="editVisisdiag=false">
      <el-form :model="form"
               label-width="100px"
               label-position="right"
               size="small"
               ref="formRules">
        <el-form-item label="直播主题"
                      prop="live_room_theme">
          <el-input v-model="form.live_room_theme"
                    placeholder="请输入直播主题"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="上课时间："
                      prop="start_time">
          <div class="">
            <el-date-picker v-model="form.start_time"
                            type="datetime"
                            style="width:260px;"
                            placeholder="请选择日期时间"
                            clearable
                            value-format="timestamp">
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button @click="editVisisdiag = false">取消</el-button>
        <el-button type="primary"
                   @click="submit()"
                   plain>确认</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { gradelist, courseChapterOne, getRoomVideoToken } from '@/request/api'
import Clipboard from 'clipboard'
import PlanDetail from '@/components/PlanComponents/PlanDetail/index'
import { adminUrl } from '@/utils/helper.js'
export default {
  components: {},
  data() {
    return {
      clipboardText: '',
      grade_id: '',
      title: '课堂',
      dialogFormVisible: false,
      bind_live_room_status: 0,
      tableData: [],
      expands: [],
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      },
      liveId: null,
      editVisisdiag: false,
      form: { live_room_theme: '', start_time: null },
      liveStatus: null,
      editRow: {},
    }
  },
  created() {},
  methods: {
    handlePreview(row) {
      if (row.baijia_resource_room_video_obj) {
        let params = {
          product_type: 1,
          course_chapter_id: row.id,
          room_id: row.baijia_resource_room_video_obj.room_id,
          video_id: row.baijia_resource_room_video_obj.video_id,
        }
        let str = adminUrl()
        this.$axios({
          url: `${str}/api/v1/back/baijia/roomVideo/getRoomVideoToken`,
          method: 'post', //可以省略 不写默认是get
          data: params,
        }).then((response) => {
          let res = response.data
          window.open(
            `https://kaoyanbox.at.baijiayun.com/web/playback/index?classid=${row.baijia_resource_room_video_obj.room_id}&token=${res.data.token}`
          )
        })
      } else {
        window.open(
          `https://kaoyanbox.at.baijiayun.com/web/room/prepare?room_id=${row.baijia_resource_room_obj.room_id}&code=${row.baijia_resource_room_obj.admin_code}`
        )
      }

      // getRoomVideoToken(data).then((res) => {
      //   console.log('res', res)
      // window.open(
      //   `https://kaoyanbox.at.baijiayun.com/web/playback/index?classid=${row.baijia_resource_room_video_obj.room_id}&token=${res.token}`
      // )
      // })
    },
    getCourseDetail(row) {
      let str = adminUrl()
      this.$axios({
        url: `${str}/api/v1/back/courseChapter`,
        method: 'get', //可以省略 不写默认是get
        params: { id: row.id },
      }).then((response) => {
        console.log('res', response)
        this.editRow = response.data.data
      })
    },
    getLiveStatus(row) {
      if (row.baijia_resource_room_obj) {
        if (row.baijia_resource_room_obj.lesson_start_end_status == 1) {
          return '进行中'
        } else {
          let nowTime = Date.now()
          if (nowTime > row.baijia_resource_room_obj.end_time) {
            return '已结束'
          } else if (nowTime < row.baijia_resource_room_obj.end_time) {
            return '未开始'
          }
        }
      }
    },
    handleEdit(row) {
      this.getCourseDetail(row)
      let nowTime = Date.now()
      if (nowTime > row.baijia_resource_room_obj.start_time) {
        this.$message.error('达到当前已设置得上课时间无法修改')
        return
      }
      this.editVisisdiag = true
      this.form.live_room_theme = row.baijia_resource_room_obj.title
      this.form.start_time = row.baijia_resource_room_obj.start_time
    },
    changeLive(row, type) {
      let datas = {}
      if (type == 1) {
        datas = {
          id: row.id,
          status: 1,
        }
        let str = adminUrl()
        this.$axios({
          url: `${str}/api/v1/back/courseChapter`,
          method: 'put', //可以省略 不写默认是get
          data: datas,
        }).then((response) => {
          this.$message.success('发布成功')
          this.classRoomList()
        })
      } else {
        datas = {
          id: row.id,
          status: 0,
        }
        let str = adminUrl()
        this.$axios({
          url: `${str}/api/v1/back/courseChapter`,
          method: 'put', //可以省略 不写默认是get
          data: datas,
        }).then((response) => {
          this.$message.success('下线成功')
          this.classRoomList()
        })
      }
    },
    formatTime(seconds) {
      if (seconds) {
        const hours = Math.floor(seconds / 3600) // 计算小时
        const minutes = Math.floor((seconds % 3600) / 60) // 计算分钟
        const remainingSeconds = seconds % 60 // 计算秒数
        if (hours > 0) {
          return `${hours}小时${minutes}分钟${remainingSeconds}秒`
        } else {
          return `${minutes}分钟${remainingSeconds}秒`
        }
      } else {
        return '暂无'
      }
    },
    closeDiag() {
      this.dialogFormVisible = false
      this.tableData = []
      this.query = {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      }
      this.liveId = null
      this.bind_live_room_status = 0
      this.grade_id = ''
      this.liveStatus = null
    },
    // 展开行变化记录
    handleExpendChange(row, expand) {
      if (expand) {
        this.expands.push(row.id + '')
      } else {
        this.expands = this.expands.filter((item) => item != row.id)
      }
    },
    change() {
      this.openRom()
    },
    open(id, bind_live_room_status, bind_live_room_course_id) {
      this.grade_id = id
      this.bind_live_room_status = bind_live_room_status
      this.dialogFormVisible = true
      if (bind_live_room_course_id != null) {
        this.liveId = bind_live_room_course_id
        this.classRoomList()
      }
    },
    //  打开直播间
    openRom() {
      let str = adminUrl()
      let params = {}
      params.grade_id = this.grade_id
      params.bind_live_room_status = this.bind_live_room_status
      this.$axios({
        url: `${str}/api/v1/back/grade/updateGradeBindLiveRoomStatus`,
        method: 'post', //可以省略 不写默认是get
        data: params,
      }).then((response) => {
        this.fetList()
      })
    },
    fetList() {
      gradelist({
        pageIndex: 1,
        pageSize: 10,
        isPaging: 0,
      }).then((response) => {
        let res = response.data
        res.data.list.map((item) => {
          if (this.grade_id == item.id) {
            this.liveId = item.bind_live_room_course_id
          }
        })
        if (this.bind_live_room_status == 1) {
          this.classRoomList()
        }
      })
    },
    classRoomList() {
      let str = adminUrl()
      this.$axios({
        url: `${str}/api/v1/back/courseChapter/list`,
        method: 'get', //可以省略 不写默认是get
        params: { product_id: this.liveId },
      }).then((response) => {
        this.tableData = response.data.data.list
        if (!this.expands.length) {
          setTimeout(() => {
            this.tableData.length &&
              this.hendleToggleExpand(this.tableData[0], true)
          }, 100)
        }
      })
    },
    hendleToggleExpand(row, expanded = true) {
      this.$refs.table.toggleRowExpansion(row, expanded)
    },
    submit() {
      let str = adminUrl()
      let datas = {
        baijia_live_room_obj: {
          assistant_teacher_list:
            this.editRow.baijia_live_room_obj.assistant_teacher_list,
          duration_time: this.editRow.baijia_live_room_obj.duration_time,
          has_student_raise:
            this.editRow.baijia_live_room_obj.has_student_raise,
          is_long_term: this.editRow.baijia_live_room_obj.is_long_term,
          master_teacher_obj:
            this.editRow.baijia_live_room_obj.master_teacher_obj,
          max_users: this.editRow.baijia_live_room_obj.max_users,
          room_id: this.editRow.baijia_live_room_obj.room_id,
          start_time: this.form.start_time,
          title: this.form.live_room_theme,
        },
        ccid: this.editRow.ccid,
        chapter_link_url: this.editRow.chapter_link_url,
        extra_type: this.editRow.extra_type,
        id: this.editRow.id,
        name: this.form.live_room_theme,
        status: this.editRow.status,
        trial: this.editRow.trial,
      }

      this.$axios({
        url: `${str}/api/v1/back/courseChapter`,
        method: 'put', //可以省略 不写默认是get
        data: datas,
      }).then((response) => {
        this.$message.success('操作成功')
        this.editVisisdiag = false
        this.classRoomList()
      })
    },
  },
}
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
  }
}
.menu-wrap {
  display: flex;
  align-items: center;
}
</style>